export default {
  methods: {
    clearObject(obj, i = 0) {
      console.log(obj, 1111);
      i++;
      if (i < 3) {
        Object.keys(obj).forEach((key) => {
          if (typeof obj[key] !== 'object') {
            obj[key] = '';
          } else {
            obj[key] = this.clearObject(obj[key], i);
          }
        });
      }
      return obj;
    }
  }
};
